module.exports = __webpack_public_path__ + "img/banner-faqs.b7310d0c.jpg";